export default "__VITE_ASSET__BznwQvuY__"